import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route  } from "react-router-dom";
import Home from "./pages/Home";
import ProductList from "./pages/ProductList/ProductList";
import ProductView from "./pages/ProductView/ProductView";
import "./App.css";
import Header from "./components/Header";
import ProductCategoryList from "./pages/ProductList/ProductCategoryList";


function App() {
  let is_visit = false
  useEffect(() => {
    if(!is_visit){
      is_visit = true 
      fetch(`https://visits.lojarc.shop/${window.location.pathname}`)
    }
  }, []);

  return (
    <div>
      <Router>
        <Header></Header>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product-category" element={<ProductCategoryList />} />
            <Route path="/products" element={<ProductList />} />
            <Route path="/product/:id" element={<ProductView />} />
          </Routes>
      </Router>
      <footer>
        <p>© 2025 LojaRC. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
